import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { DataGrid } from "@mui/x-data-grid";
import { debounce } from "@mui/material";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Close from "../../assets/images/close-icon.png";
import Typography from "@mui/material/Typography";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import Box from "@mui/material/Box";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { usePermissions } from "../../context/permissionContext";
import { validatePermission } from "../../utils/permissionUtils";
import Loader from "../../components/Loader/Loader";
import "../../components/common/css/datatable.scss";

const ManageDesignation = () => {
  const [open, setOpen] = useState(false);

  const handleOpen = (row) => {
    setOpen(true);
    setID(row?.id);
    setDesignationName(row?.designation);
    setRoleName(row?.name);
    setLevelName(row?.level);
  };
  const [roleName, setRoleName] = useState();
  const [designationName, setDesignationName] = useState();
  const [levelName, setLevelName] = useState();

  const handleClose = () => setOpen(false);
  const [designation, setRole] = useState();
  const [name, setName] = useState();
  const [level, setLevel] = useState();
  const [openModal, setOpenModal] = React.useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  let token = localStorage.getItem("accessToken");
  const dispatch = useDispatch();
  const [id, setID] = useState();
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [pageState, setPageState] = useState({
    data: [],
    total: 0,
    page: 1,
    pageSize: 9,
  });
  const { permissions, permissionsMapping } = usePermissions();

  const {
    register,
    reset,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "all",
  });

  const hasEditPermission = validatePermission(
    "Users Management - Manage Designations:Edit",
    permissions,
    permissionsMapping
  );
  const hasDeletePermission = validatePermission(
    "Users Management - Manage Designations:Delete",
    permissions,
    permissionsMapping
  );

  const requestColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 160,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            {hasEditPermission && (
              <div
                className="editButton"
                onClick={() => handleOpen(params.row)}
              >
                <EditOutlinedIcon />
              </div>
            )}
            {hasDeletePermission && (
              <div
                className="deleteButton"
                onClick={() => deleteFunction(params.row.id)}
              >
                <DeleteOutlineIcon />
              </div>
            )}
          </div>
        );
      },
    },
  ];

  const userColumns = [
    { field: "id", headerName: "ID", width: 100 },

    {
      field: "designation",
      headerName: "Designation",
      width: 250,
    },
    {
      field: "name",
      headerName: "Name",
      width: 250,
    },
    {
      field: "level",
      headerName: "Level",
      width: 250,
    },
    {
      field: "createdBy",
      headerName: "Created By",
      width: 250,
      renderCell: (params) => {
        const d = params?.row?.createdBy[0];
        return <span>{d?.firstname}</span>;
      },
    },
    {
      field: "updatedBy",
      headerName: "Updated By",
      width: 250,
      renderCell: (params) => {
        const d = params?.row?.updatedBy[0];

        return <span>{d?.firstname}</span>;
      },
    },
  ];

 

  const fetchRolesData = () => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    setPageState((old) => ({ ...old }));
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "get-designation",
      headers: {
        "x-access-token": token,
      },

      data: {
        page: pageState.page,
        limit: pageState.pageSize,
      },
    };

    axios(config)
      .then(function (response) {
        setLoading(false);
        setPageState((old) => ({
          ...old,
          data: response.data.data.rows,
          total: response.data.data.count,
        }));
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error?.response?.data?.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };

  useEffect(() => {
    fetchRolesData();
  }, [pageState.page, pageState.pageSize, query]);

  const handleRole = (e) => {
    // let result = e.target.value.replace(/[^a-z]/gi,"");
    let result = e.target.value;

    setRole(result);
  };

  const handleName = (e) => {
    let nameValue = e.target.value.replace(/[^a-z]/gi, "");
    setName(nameValue);
  };

  const updateName = (e) => {
    let getName = e.target.value.replace(/[^a-z]/gi, "");
    setRoleName(getName);
  };

  const updateDesignationName = (e) => {
    let getDesignationName = e.target.value;
    setDesignationName(getDesignationName);
  };

  //delete-roles
  const deleteFunction = (id) => {
    const token = localStorage.getItem("accessToken");
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this Designation!",
      icon: "warning",
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        var config = {
          method: "patch",
          url: process.env.REACT_APP_API + "delete-designation",
          headers: {
            "x-access-token": token,
          },
          data: {
            roledesign_id: id,
          },
        };

        axios(config)
          .then(function (response) {
            if (response.status == 200) {
              setLoading(false);
              // setOpen(false);
              Swal.fire({
                title: "Designation is deleted Successfully",
                timer: 2500,
                timerProgressBar: true,
                icon: "success",
                confirmButtonText: "OK",
                showCloseButton: true,
              });
            }
            fetchRolesData();
          })

          .catch(function (error) {
            setLoading(false);
            if (error.response !== "" && error.response.data.message !== "") {
              Swal.fire({
                title: "Error",
                timer: 2500,
                timerProgressBar: true,
                text: error.response.data.message,
                icon: "error",
                confirmButtonColor: "#f27474",
                confirmButtonText: "OK",
                dangerMode: true,
                showCloseButton: true,
              });
            }
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        setLoading(false);
        Swal.fire("Cancelled", "Designation is not deleted", "error");
      }
    });
  };

  //add-new-roles
  const onSubmit = () => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "save-designation",
      headers: {
        "x-access-token": token,
      },
      data: {
        designation: designation,
        name: name,
        level: level,
        // createdBy: currencyRate,
      },
    };
    axios(config)
      .then(function (response) {
        if (response.data.status == 200) {
          setLoading(false);
          setOpen(false);

          Swal.fire({
            title: "Designation Added Successfully",
            timer: 2500,
            timerProgressBar: true,
            icon: "success",
            confirmButtonText: "OK",
            showCloseButton: true,
          });
        }
        setOpenModal(false);
        fetchRolesData();

        // setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
        if (error.response !== "" && error.response.message !== "") {
          Swal.fire({
            title: "Error",
            timer: 2500,
            timerProgressBar: true,
            text: error.response.data.message,
            icon: "error",
            confirmButtonColor: "#f27474",
            confirmButtonText: "OK",
            dangerMode: true,
            showCloseButton: true,
          });
        }
      });
  };

  //update-role-name
  const onSubmitRole = () => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    var config = {
      method: "patch",
      url: process.env.REACT_APP_API + "update-designation",
      headers: {
        "x-access-token": token,
      },
      data: {
        roledesign_id: id,
        designation: designationName,
        name: roleName,
        level: levelName,
        // createdBy: currencyRate,
      },
    };
    axios(config)
      .then(function (response) {
        if (response.data.status == 200) {
          setLoading(false);
          setOpen(false);
          Swal.fire({
            title: "Designation Updated Successfully",
            timer: 2500,
            timerProgressBar: true,
            icon: "success",
            confirmButtonText: "OK",
            showCloseButton: true,
          });
        }
        setOpenModal(false);
        fetchRolesData();

        // setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
        if (error.response !== "" && error.response.message !== "") {
          Swal.fire({
            title: "Error",
            timer: 2500,
            timerProgressBar: true,
            text: error.response.data.message,
            icon: "error",
            confirmButtonColor: "#f27474",
            confirmButtonText: "OK",
            dangerMode: true,
            showCloseButton: true,
          });
        }
      });
  };
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />

        <div className="datatable">
          <Loader isLoading={loading} />

          <div className="datatableTitle manageUser-top">
            <h5 className="h5Title" style={{ textAlign: "center" }}>
              Manage System Designations
            </h5>
            {hasEditPermission && <button
              className="link"
              onClick={handleOpenModal}
              style={{ background: "transparent" }}
            >
              Add New
            </button>}
          </div>

          <DataGrid
            className="datagrid"
            autoHeight
            rows={pageState.data}
            rowCount={pageState.total}
            rowsPerPageOptions={[10, 30, 50, 70, 100]}
            pagination
            page={pageState.page - 1}
            pageSize={pageState.pageSize}
            paginationMode="server"
            onPageChange={(newPage) => {
              setPageState((old) => ({ ...old, page: newPage + 1 }));
            }}
            onPageSizeChange={(newPageSize) =>
              setPageState((old) => ({ ...old, pageSize: newPageSize }))
            }
            columns={userColumns.concat(requestColumn)}
          />
        </div>
        {/* <form onSubmit={handleSubmit(onSubmit)}> */}
        <Modal
          open={openModal}
          onClose={handleCloseModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="modal-popup">
            <div className="modal-top">
              <Typography id="modal-modal-title" variant="h6" component="h2">
                New Designation Entry
              </Typography>
              <Button className="closeBtn" onClick={() => setOpenModal(false)}>
                <img src={Close} alt="close-icon" />
              </Button>
            </div>
            <Typography id="modal-modal-description" sx={{ mt: 1 }}>
              <div className="new">
                <div className="newContainer">
                  <div
                    className="bottom"
                    style={{ boxShadow: "none", padding: "0" }}
                  >
                    <div className="right">
                      <form className="accredited-investorForm">
                        <div className="formInput" id="commissionInput">
                          <label>Designation</label>
                          <input
                            type="text"
                            name="designation"
                            placeholder="Enter Designation"
                            value={designation}
                            className="custome-input"
                            {...register("designation", {
                              pattern: {
                                value: /^[a-zA-Z_ ]*$/,
                                message: "Please enter only characters",
                              },
                              required: "This field is required",
                            })}
                            onChange={handleRole}
                          />
                          {errors.designation && (
                            <div className="invalid-feedback">
                              {errors.designation.message}
                            </div>
                          )}
                        </div>

                        <div className="formInput" id="commissionInput">
                          <label>Name</label>
                          <input
                            type="text"
                            name="designation_name"
                            placeholder="Enter Name"
                            value={name}
                            className="custome-input"
                            {...register("designation_name", {
                              required: "This field is required",
                            })}
                            onChange={handleName}
                          />

                          {errors.designation_name && (
                            <div className="invalid-feedback">
                              {errors.designation_name.message}
                            </div>
                          )}
                        </div>

                        <div className="formInput" id="commissionInput">
                          <label>Level</label>
                          <select
                            name="level_name"
                            {...register("level_name", {
                              required: "This field is required",
                            })}
                            onChange={(e) => setLevel(e.target.value)}
                          >
                            <option value="" disabled selected hidden>
                              Select Level
                            </option>
                            <option value="1">Level 1</option>
                            <option value="2">Level 2</option>
                            <option value="3">Level 3</option>
                            <option value="4">Level 4</option>
                            <option value="5">Level 5</option>
                          </select>

                          {errors.level_name && (
                            <div className="invalid-feedback">
                              {errors.level_name.message}
                            </div>
                          )}
                        </div>

                        <div className="item accreditedItem">
                          <div className="details profile-info">
                            <div className="submitButton">
                              <button
                                className={
                                  !name || !designation || !level
                                    ? "disable-approveButton"
                                    : "approveButton"
                                }
                                type="button"
                                disabled={!name || !designation || !level}
                                onClick={onSubmit}
                              >
                                Add
                              </button>

                              <button
                                className="cancelButton"
                                type="button"
                                onClick={() => setOpenModal(false)}
                              >
                                Close
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </Typography>
          </Box>
        </Modal>
        {/* </form> */}
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="modal-popup">
            <div className="modal-top">
              <Typography id="modal-modal-title" variant="h6" component="h2">
                Update Designation
              </Typography>
              <Button className="closeBtn" onClick={() => setOpen(false)}>
                <img src={Close} alt="close-icon" />
              </Button>
            </div>
            <Typography id="modal-modal-description" sx={{ mt: 1 }}>
              <div className="new">
                <div className="newContainer">
                  <div
                    className="bottom"
                    style={{ boxShadow: "none", padding: "0" }}
                  >
                    <div className="right">
                      <form className="accredited-investorForm">
                        <div className="formInput" id="commissionInput">
                          <label>Designation</label>
                          <input
                            type="text"
                            name="designation"
                            placeholder="Enter Designation"
                            {...register("designation", {
                              required: "Designation is required",
                            })}
                            value={designationName}
                            onChange={updateDesignationName}
                          />
                          {errors.designation && (
                            <div className="invalid-feedback">
                              {errors.designation.message}
                            </div>
                          )}
                        </div>

                        <div className="formInput" id="commissionInput">
                          <label>Name</label>
                          <input
                            type="text"
                            name="name"
                            {...register("name", {
                              required: "Name is required",
                            })}
                            placeholder="Enter Name"
                            value={roleName}
                            onChange={updateName}
                          />

                          {errors.name && (
                            <div className="invalid-feedback">
                              {errors.name.message}
                            </div>
                          )}
                        </div>

                        <div className="formInput" id="commissionInput">
                          <label>Level</label>
                          <select
                            name="level"
                            {...register("level", {
                              required: "This field is required",
                            })}
                            onChange={(e) => setLevelName(e.target.value)}
                            value={levelName}
                          >
                            <option value="" disabled selected hidden>
                              Select Level
                            </option>
                            <option value="1">Level 1</option>
                            <option value="2">Level 2</option>
                            <option value="3">Level 3</option>
                            <option value="4">Level 4</option>
                            <option value="5">Level 5</option>
                          </select>

                          {errors.level && (
                            <div className="invalid-feedback">
                              {errors.level.message}
                            </div>
                          )}
                        </div>

                        <div className="item accreditedItem">
                          <div className="details profile-info">
                            <div className="submitButton">
                              <button
                                className={
                                  !roleName || !designationName || !levelName
                                    ? "disable-approveButton"
                                    : "approveButton"
                                }
                                type="button"
                                disabled={
                                  !roleName || !designationName || !levelName
                                }
                                onClick={onSubmitRole}
                              >
                                Update
                              </button>

                              <button
                                className="cancelButton"
                                type="button"
                                onClick={() => setOpen(false)}
                              >
                                Close
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </Typography>
          </Box>
        </Modal>
      </div>
    </div>
  );
};
export default ManageDesignation;
